var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrganisation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15.42,
    height: 14.564,
    viewBox: "0 0 15.42 14.564",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3626",
    "data-name": "Path 3626",
    d: "M10.15-17a1.614,1.614,0,0,1,1.656,1.564h0v5.205h2.259A1.321,1.321,0,0,1,15.42-8.95h0v6.087a.44.44,0,0,1-.452.427H.452A.44.44,0,0,1,0-2.863H0V-8.95a1.321,1.321,0,0,1,1.355-1.28H3.614v-5.205A1.614,1.614,0,0,1,5.271-17H10.15ZM8.313-5.11h-1.2a.147.147,0,0,0-.151.142h0V-3.29H8.463V-4.968a.147.147,0,0,0-.151-.142ZM10.15-16.147H5.271a.734.734,0,0,0-.753.711h0V-3.29H6.054V-4.968a1.027,1.027,0,0,1,1.054-1h1.2a1.027,1.027,0,0,1,1.054,1h0V-3.29H10.9V-15.436a.734.734,0,0,0-.753-.711ZM3.614-9.377H1.355A.44.44,0,0,0,.9-8.95h0V-3.29H3.614Zm10.451,0H11.806V-3.29h2.711V-8.95a.44.44,0,0,0-.452-.427Zm-11.8.944a.43.43,0,0,1,.454.4h0v1.767a.43.43,0,0,1-.454.4.43.43,0,0,1-.454-.4h0V-8.032A.43.43,0,0,1,2.268-8.433Zm10.885,0a.43.43,0,0,1,.454.4h0v1.767a.43.43,0,0,1-.454.4.43.43,0,0,1-.454-.4h0V-8.032A.43.43,0,0,1,13.153-8.433ZM5.9-15.287a.44.44,0,0,1,.454.425h0V-8a.44.44,0,0,1-.454.425A.44.44,0,0,1,5.442-8h0v-6.86A.44.44,0,0,1,5.9-15.287Zm1.814,0a.44.44,0,0,1,.454.425h0V-8a.44.44,0,0,1-.454.425A.44.44,0,0,1,7.257-8h0v-6.86A.44.44,0,0,1,7.71-15.287Zm1.814,0a.44.44,0,0,1,.454.425h0V-8a.44.44,0,0,1-.454.425A.44.44,0,0,1,9.071-8h0v-6.86A.44.44,0,0,1,9.524-15.287Z",
    transform: "translate(0 17)",
    fill: "#06233d"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3625",
    "data-name": "Path 3625",
    d: "M-996,159.754H648.844V-4624H-996Z",
    transform: "translate(996 4624)",
    fill: "#06233d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2349",
    "data-name": "Group 2349",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2348",
    "data-name": "Group 2348",
    transform: "translate(-853.263 -3946.768)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3624",
    "data-name": "Path 3624",
    d: "M-5-22H18.987V1.131H-5Z",
    transform: "translate(853.979 3964.485)",
    fill: "#06233d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganisation);
export default __webpack_public_path__ + "static/media/organisation.1c5c0b72d7d501d0dd88f96e7b27b745.svg";
export { ForwardRef as ReactComponent };